import { render } from "./Notification.vue?vue&type=template&id=ce0700ee"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import exportComponent from "/Users/amane/Documents/-4°/AmaneStudio/A++/Amane.dev/portfolio.amane.dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__